import { BottomContent } from './BottomContent/BottomContent';
import { Description } from './Description/Description';

export const SharedAutoDelete = {
    Description,
    BottomContent,
};
